/*@flow*/
import useSections from './useSections';
import resourceFilters from 'lib/resource/filters';
import resourceFilterNames from './resourceFilterNames';
import isEmbedded from 'lib/isEmbedded';
import getFilterName from './getFilterName';
import LTFiltersSectionTemplate from './LTFiltersSectionTemplate';
import * as t from 'lib/t';
import Struct from 'lib/proforma/templates/Struct';
import { type StructType } from 'lib/t/types';

export default function useFiltersSectionsPanelType(filters: {
  type?: string[],
}): StructType {
  const sections = useSections(filters);

  const reduceResources = (s, v) => {
    const config = resourceFilters[v];
    let filterName: string = getFilterName(v);
    // Contact filters are hidden of embedded maps
    if (filterName === 'contacts' && isEmbedded()) return s;
    return config ? { ...s, [filterName]: resourceFilters[v] } : s;
  };
  const init = {
    type: t.list(t.String).opt({
      template: LTFiltersSectionTemplate,
    }),
  };
  const filtersConfig = sections.reduce(reduceResources, init);

  const order = ['type'].concat(resourceFilterNames);
  const noFieldset = {
    legend: '',
    template: Struct.clone({
      Fieldset: ({ children }) => children,
    }),
  };

  const filters2 = t.struct(filtersConfig).opt({ ...noFieldset, order });
  return ((t
    .struct({ filters: filters2 })
    .opt<any>(noFieldset): any): StructType);
}
